import { get as o } from "theme-ui";
import { keyframes as e } from "@emotion/react";
const a = e({
  from: { height: 0 },
  to: { height: "var(--radix-collapsible-content-height)" }
}), i = e({
  from: { height: "var(--radix-collapsible-content-height)" },
  to: { height: 0 }
}), n = {
  overflow: "hidden",
  '&[data-state="open"]': (t) => ({
    animation: `${a} ${o(t, "transitions.default")}`
  }),
  '&[data-state="closed"]': (t) => ({
    animation: `${i} ${o(t, "transitions.default")}`
  })
}, r = {
  collapsibleContent: n
};
export {
  n as collapsibleContent,
  r as collapsibleTheme
};
